import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';

import { SidebarCellComponent } from './sidebar-cell.component';

@NgModule({
  declarations: [SidebarCellComponent],
  imports: [CommonModule, NgxBootstrapIconsModule, TooltipModule],
  exports: [SidebarCellComponent],
})
export class SidebarCellModule {}
